import Breadcrumbs from "./Breadcrumbs";

export default function PageHero({
  eyebrow,
  title,
  subtitle,
  breadcrumbs,
  align = "left",
}) {
  return (
    <section
      data-testid="page-hero"
      className="bg-ivory border-b border-soft-grey"
    >
      <div className="container-px max-w-[1400px] mx-auto pt-32 md:pt-40 pb-16 md:pb-24">
        {breadcrumbs && breadcrumbs.length > 0 && (
          <div className="mb-10">
            <Breadcrumbs items={breadcrumbs} />
          </div>
        )}
        <div className={`grid md:grid-cols-12 gap-8 ${align === "center" ? "text-center" : ""}`}>
          <div className={align === "center" ? "md:col-span-12" : "md:col-span-8"}>
            {eyebrow && <div className="overline mb-6">{eyebrow}</div>}
            <h1 className="h-display text-5xl md:text-6xl lg:text-7xl text-navy">
              {title}
            </h1>
          </div>
          {subtitle && (
            <div className={align === "center" ? "md:col-span-10 md:col-start-2" : "md:col-span-8"}>
              <p className="mt-7 body-lg text-charcoal/75 max-w-2xl">{subtitle}</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
